import React from "react";
import { Link } from "react-router-dom";
import { Stethoscope, ArrowLeft } from "lucide-react";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen flex bg-[hsl(var(--bg-base))]">
      {/* Left form column */}
      <div className="flex-1 flex flex-col">
        <header className="px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-10 h-10 rounded-xl bg-white overflow-hidden flex items-center justify-center shadow-sm p-1.5">
              <img src="/iatros-logo-icon-simple.svg" alt="Iatrós Logo" className="w-full h-full object-contain" />
            </div>
            <div className="text-[15px] font-semibold" style={{fontFamily:"'Outfit',sans-serif"}}>Iatrós</div>
          </Link>
          <Link to="/" className="text-sm text-[hsl(var(--text-tertiary))] hover:text-[hsl(var(--text-primary))] inline-flex items-center gap-1">
            <ArrowLeft className="w-4 h-4" /> Início
          </Link>
        </header>
        <div className="flex-1 flex items-center justify-center px-6 py-10">
          <div className="w-full max-w-md ds-fade-up">
            <h1 className="text-3xl font-semibold tracking-tight" style={{fontFamily:"'Outfit',sans-serif"}}>{title}</h1>
            {subtitle && <p className="text-[hsl(var(--text-secondary))] mt-2">{subtitle}</p>}
            <div className="mt-8">{children}</div>
            {footer && <div className="mt-6">{footer}</div>}
          </div>
        </div>
        <footer className="px-8 py-6 text-xs text-[hsl(var(--text-tertiary))] flex gap-4">
          <Link to="/legal/termos" className="hover:text-[hsl(var(--text-primary))]">Termos</Link>
          <Link to="/legal/privacidade" className="hover:text-[hsl(var(--text-primary))]">Privacidade</Link>
        </footer>
      </div>

      {/* Right brand panel */}
      <div className="hidden lg:flex w-[42%] bg-[hsl(var(--brand))] text-white flex-col justify-between p-10 relative overflow-hidden">
        {/* Glow and Watermark */}
        <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-white/5 blur-3xl" />
        <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-white/5 blur-3xl" />
        <div className="absolute right-[-10%] bottom-[-5%] w-[450px] h-[450px] opacity-[0.13] pointer-events-none select-none transform rotate-[-15deg]">
          <img src="/iatros-logo-icon-detailed-dark.svg" alt="" className="w-full h-full object-contain" />
        </div>
        <div className="relative">
          <div className="text-[11px] uppercase tracking-[0.18em] text-white/60">Plataforma clínica</div>
          <h2 className="text-3xl font-semibold mt-4 leading-tight max-w-md" style={{fontFamily:"'Outfit',sans-serif"}}>
            Cuidado clínico organizado, com a calma de quem trata pessoas.
          </h2>
        </div>
        <div className="relative space-y-4 max-w-md">
          <div className="text-white/90 leading-relaxed">
            Uma plataforma segura e intuitiva, projetada para otimizar sua rotina e permitir que você foque no que mais importa: o cuidado com seus pacientes.
          </div>
        </div>
      </div>
    </div>
  );
}
